var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.popinModal.id,
        "aria-labelledby": _vm.popinModal.label,
        "show-close-button": _vm.popinModal.showCloseButton,
      },
      on: { "ob1-popin-modal-click": _vm.closePopin },
    },
    [
      _c("h4", { attrs: { id: "modalTitle" } }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pt-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "accordion" },
            _vm._l(_vm.steps, function (step, index) {
              return _c("div", { key: "step-" + index }, [
                _c("div", { staticClass: "card multi" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { id: "heading-step-" + index },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "collapsed",
                          attrs: {
                            "data-bs-toggle": "collapse",
                            "data-bs-target": "#step-collapse-" + index,
                            "aria-controls": "#" + "step-collapse-" + index,
                            "aria-expanded":
                              _vm.expandedStepIndex === index
                                ? "true"
                                : "false",
                          },
                        },
                        [
                          _c("span", { staticClass: "accordion-card-title" }, [
                            _c("span", {
                              staticClass: "step-bubble-popin me-1",
                              attrs: { "aria-hidden": "true" },
                              domProps: { innerHTML: _vm._s(step.number) },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "accordion-title",
                              attrs: { itemprop: "name" },
                              domProps: { innerHTML: _vm._s(step.title) },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "accordion-icon",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      class: { show: _vm.expandedStepIndex === index },
                      attrs: {
                        id: "step-collapse-" + index,
                        "aria-labelledby": "step-attributes-" + index,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "accordion-card-body standard" },
                        [
                          _c(
                            "ul",
                            { staticClass: "list ob1-list-tick" },
                            _vm._l(
                              step.attributes,
                              function (attribute, pointer) {
                                return _c(
                                  "li",
                                  { key: "step-attribute-" + pointer },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(attribute.text),
                                      },
                                    }),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }